import React from 'react';
import { BrandedLoader } from '@orrekie/ui';
import { useLoginForm } from '@orrekie/hooks';
// You can replace this with your shared Input/Button components as you build them

console.log('[DEBUG] Rendering shared/ui/auth/LoginForm.jsx');

export default function LoginForm({ auth, redirectUrl, InputComponent, ButtonComponent, onForgotPassword, onRegister, title = 'Sign in to your account' }) {
  const {
    register,
    handleSubmit,
    errors,
    onSubmit,
    isLoading,
    progressMessage,
    error,
  } = useLoginForm({ auth, redirectUrl });

  console.log('[LoginForm] Rendering login form with auth:', auth, 'redirectUrl:', redirectUrl);

  if (isLoading) {
    console.log('[LoginForm] Loading state active, showing loader');
    return (
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#fff' }}>
        <BrandedLoader message={progressMessage || 'Signing you in, please wait…'} />
      </div>
    );
  }

  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-900 mb-6">{title}</h2>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
        {InputComponent ? (
          <InputComponent
            label="Email address"
            id="email"
            type="email"
            autoComplete="email"
            error={errors.email?.message}
            {...register('email')}
          />
        ) : (
          <input
            id="email"
            type="email"
            placeholder="Email address"
            {...register('email')}
            className="w-full border rounded p-2"
          />
        )}
        {InputComponent ? (
          <InputComponent
            label="Password"
            id="password"
            type="password"
            autoComplete="current-password"
            error={errors.password?.message}
            {...register('password')}
          />
        ) : (
          <input
            id="password"
            type="password"
            placeholder="Password"
            {...register('password')}
            className="w-full border rounded p-2"
          />
        )}
        {error && (
          <div className="rounded-md bg-red-50 p-4">
            <div className="flex">
              <div className="ml-3">
                <h3 className="text-sm font-medium text-red-800">{error}</h3>
              </div>
            </div>
          </div>
        )}
        <div>
          {ButtonComponent ? (
            <ButtonComponent type="submit" disabled={isLoading}>
              {isLoading ? 'Signing in...' : 'Sign in'}
            </ButtonComponent>
          ) : (
            <button
              type="submit"
              disabled={isLoading}
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-orrekie-600 hover:bg-orrekie-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orrekie-500 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? 'Signing in...' : 'Sign in'}
            </button>
          )}
        </div>
      </form>
      <div className="mt-6 flex flex-col items-center space-y-2 text-sm">
        {onForgotPassword ? (
          <button type="button" onClick={onForgotPassword} className="text-orrekie-600 hover:text-orrekie-500 font-medium">Forgot your password?</button>
        ) : (
          <a href="/forgot-password" className="text-orrekie-600 hover:text-orrekie-500 font-medium">Forgot your password?</a>
        )}
        <span className="text-gray-400">|</span>
        {onRegister ? (
          <button type="button" onClick={onRegister} className="text-orrekie-600 hover:text-orrekie-500 font-medium">Don't have an account? Register</button>
        ) : (
          <a href="/register" className="text-orrekie-600 hover:text-orrekie-500 font-medium">Don't have an account? Register</a>
        )}
      </div>
    </div>
  );
}
